import { render, staticRenderFns } from "./message.vue?vue&type=template&id=21aee18a&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=21aee18a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aee18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21aee18a')) {
      api.createRecord('21aee18a', component.options)
    } else {
      api.reload('21aee18a', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=21aee18a&scoped=true", function () {
      api.rerender('21aee18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/components/message.vue"
export default component.exports